import React from 'react';
import Hero from '../components/sections/Hero';
import AsSeenOn from '../components/sections/AsSeenOn';
import Ecosystem from '../components/sections/Ecosystem';
import Services from '../components/sections/Services';
import Cta from '../components/sections/Cta';
import SeoBlock from '../components/sections/SeoBlock';
import TestimonialCarousel from '../components/sections/TestimonialCarousel';

const Home = () => {
  return (
    <>
      <Hero />
      <Ecosystem />
      <TestimonialCarousel />
      <Services />
      <AsSeenOn />
      <Cta />
      <SeoBlock />
    </>
  );
};

export default Home;